import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footerPart">
            <div className="text">
                <h1>Travel Mania</h1>
                <small>Copyright @ Travel Mani 2021</small>
            </div>
        </div>
    );
};

export default Footer;